import APP from 'app'

export const adsList = [
  {
    ads: {
      100: [],
      120: [],
      260: [],
      300: [],
      550: [],
    },
    campaign: {
      basePath: '',
      endAt: Date.now() + 10000,
      link: '',
      name: '',
      startAt: new Date('2021-10-29T07:43:12.667Z').valueOf(),
    },
    client: {
      name: '',
    },
    institutionsIds: [],
    tournamentsIds: [],
  },
  {
    ads: {
      100: ['200x200_1.jpg'],
      120: ['450x150_1.jpg'],
      260: ['260x100_1.jpg', '450x150_1.jpg'],
      300: ['200x200_1.jpg'],
      550: ['600x450_1.jpg', '800x540_1.jpg'],
    },
    campaign: {
      basePath: `${APP.static_url}/content/soccercup/202509/`,
      endAt: 0,
      link: '/st/11f08a8ea3016830b625cd83d37e0eb0',
      name: 'KMX COPA 2025 ASOPARTES',
      startAt: new Date('2022-02-01T07:43:12.667Z').valueOf(),
    },
    client: {
      name: 'SoccerCup',
    },
    institutionsIds: [],
    // institutionsIds: ['11ea1b92e0dee600932997dab6868a51'],
    tournamentsIds: [],
  },
  {
    ads: {
      100: ['200x200_2.jpg'],
      120: ['450x150_2.jpg'],
      260: ['260x100_2.jpg', '450x150_2.jpg'],
      300: ['200x200_2.jpg'],
      550: ['600x450_2.jpg'],
    },
    campaign: {
      basePath: `${APP.static_url}/content/soccercup/202509/`,
      endAt: 0,
      link: '/st/11f098e81b0a6b50afbd11b2b2a3953f',
      name: 'KMX COPA BOGOTÁ 2025 ASOPARTES',
      startAt: new Date('2022-02-01T07:43:12.667Z').valueOf(),
    },
    client: {
      name: 'SoccerCup',
    },
    institutionsIds: ['11ea1b92e0dee600932997dab6868a51'],
    tournamentsIds: ['11f098e81b0a6b50afbd11b2b2a3953f'],
  },
]

export const getCampaign = (institutionId, tournamentId, size) => {
  const now = Date.now()
  let list = adsList.filter(
    (ad) =>
      ad.ads[size]?.length > 0 &&
      (!ad.campaign.startAt || ad.campaign.startAt <= now) &&
      (!ad.campaign.endAt || ad.campaign.endAt >= now),
  )

  if (institutionId) {
    list = list.filter((ad) => !ad.institutionsIds?.length || ad.institutionsIds.includes(institutionId))
  }

  if (tournamentId) {
    list = list.filter((ad) => !ad.tournamentsIds?.length || ad.tournamentsIds.includes(tournamentId))
  }

  const withContext = list.filter((ad) => ad.institutionsIds?.length || ad.tournamentsIds?.length)
  list = withContext.length ? withContext : list

  const random = Math.floor(Math.random() * list.length)
  return list[random]
}
